import { render, staticRenderFns } from "./ReceivingForm.vue?vue&type=template&id=4d80b64b&scoped=true&"
import script from "./ReceivingForm.vue?vue&type=script&lang=js&"
export * from "./ReceivingForm.vue?vue&type=script&lang=js&"
import style0 from "./ReceivingForm.vue?vue&type=style&index=0&id=4d80b64b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d80b64b",
  null
  
)

export default component.exports